module.exports = __webpack_public_path__ + "img/collection-engagementRingsRedgold@2x.6d584a0.jpg";